import React, {Fragment, useState } from 'react';
import createForm from "./Form";
import TextInput from "../../form/TextInput";
import Select from "../../form/Select";
import { ifCompletedInput } from "../../../utils/other";
import classNames from 'classnames';
import Icon from "../../form/Icon";
import PaymentControl from "../../form/purchase/payment";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import Modal from "../../layout/Modal";
import Portal from "../../layout/Portal";
import { UnitFormatter, remoteLanguageFormatter, CurrencyFormatter, PartnerSelect} from "../../../utils/formatters";
import Invoice from "../OperationList/Elements/Invoice";
import get from "../../../utils/get";
import {loadComponent, loadComponentById} from "../../../utils/components";
import { 
    PAYMENT_PRICE_TYPE_UNIT_NET_PRICE,
    Price, PriceView, calculateItemPrice 
} from "../../classes/Price";
import DateTimeInput from "../../form/DateTimeInput";
import isEqual from "lodash-es/isEqual";
import {sendRequest} from "../../../utils/request";
import moment from "moment";
import DetailsButton from "../../form/DetailsButton";
import PrintButton from "../../form/PrintButton";

const sortable = true;
const filterable = true;

const Actions = (propsTop) => {
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    return <div>
        {deleting && <Portal>
            <Modal
                header="Törlés"
                state="on"
                buttons={[
                    {
                        text: "Törlés",
                        props: {
                            color: "danger",
                            disabled: loading
                        },
                        onClick: async (e) => {
                            if (loading) return;
                            e && e.preventDefault();
                            setLoading(true);
                            await propsTop.onItemRemove(propsTop.item);
                            setDeleting(false);
                            setLoading(false);
                        }
                    },
                    {
                        text: "Mégse",
                        props: {
                            color: "default",
                            disabled: loading
                        },
                        onClose: true,
                        onClick: async () => {
                            try {
                                setDeleting(false);
                                setLoading(false);
                            } catch (e) {
                            }
                        }
                    }
                ]}
            >
                Biztosan törlöd ezt a tételt?
            </Modal>
        </Portal>}
        <span className={classNames("btn btn-danger btn-xs", {disabled: deleting || propsTop.disabled || loading})} onClick={() => {
            if (deleting || propsTop.disabled || loading) return;
            setDeleting(true);
        }}><Icon lib="fa" name="trash"/></span>
    </div>
}

class InvoicingForm extends React.Component {

    state = {
        invoicingitem_type: null,
        addItem: false,
        item: null
    }

    convert = (row) => {
        row.qty = row.amount || 0;
        return row;
    }

    getValue = (name) => {
        if (name === "invoice.comment") {
            name = "comment";
        }
        return get(this.props.values, name, undefined);
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        if (!props.disabled) {
            const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
            props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
            if (this.props[name]) {
                props = {
                    ...this.props[name],
                    ...props,
                    disabled: this.props[name].disabled || props.disabled
                };
            }
        }
        return props;
    }

    setPrice = (field, newItem, oldItem) => {
        const saleprice = calculateItemPrice("saleprice", field, newItem, oldItem, PAYMENT_PRICE_TYPE_UNIT_NET_PRICE);
        saleprice.setPrice(newItem.saleprice);
        const listprice = calculateItemPrice("listprice", field, newItem, oldItem, PAYMENT_PRICE_TYPE_UNIT_NET_PRICE);
        listprice.setPrice(newItem.listprice);
        saleprice.boundTo(newItem, "saleprice");
        listprice.boundTo(newItem, "listprice");
        newItem.saleprice = saleprice.getPrice();
        newItem.listprice = listprice.getPrice();
        return newItem;
    }

    componentDidMount() {
        this.loadIsCalculator();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.values[this.props.componentConfig.idfield], prevProps.values[prevProps.componentConfig.idfield])) {
            this.loadIsCalculator();
        }
    }

    loadIsCalculator = () => {
        this.itemsRequest && this.itemsRequest.abort();
        this.setState({
            calculator: false
        }, () => {
            if (this.props.values[this.props.componentConfig.idfield]) {
                this.itemsRequest = sendRequest({
                    option: "componentlist",
                    parentcomponent: this.props.componentConfig.componentname,
                    parentid: this.props.values[this.props.componentConfig.idfield],
                    listfield: "items",
                    filter: [{field: "calculator", operator: "not isnull"}],
                    withheader: 1,
                    itemsperpage: 1,
                }, {showError: false});
                this.itemsRequest.then((data) => {
                    this.setState({calculator: !!data.items.length});
                });
            }
        });
    }

    addItem = (value) => {
        if (value.vat) {
            value = this.setPrice('qty', value, value);
        }
        const items = [...(this.props.values.items || []), value];
        this.props.setFieldValue('items', items);
    }

    loadItem = async (value, values) => {
        const item = await loadComponentById(value.component_type, value.component_id, ['id', 'name', 'calculator', 'unit', 'listprice', 'vat', 'currency', 'comment', "qty", "saleprice", "calculator"], {
            invoicing: {...this.props.values, ...values, seller: this.props.pos.partner.partner_id}
        });
        value = { ...value, ...item, component_type: value.component_type, component_id: value.component_id };
        this.addItem(value);
    }

    render() {
        const startdate = this.props.values.startdate || moment().subtract(1, "months").startOf('month').format("YYYY-MM-DD") + " 00:00:00";
        const enddate = this.props.values.enddate || moment().subtract(1, "months").endOf('month').format("YYYY-MM-DD") + " 23:59:59";
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-8">
                        <Select
                            label="Vevő"
                            name="customer"
                            component="partner"
                            optionsTemplate={PartnerSelect}
                            objectValue={false}
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            value={this.props.values.customer}
                            saveChanges={this.props.setFieldValue}
                            { ...this.props.getFieldProps('customer') }
                        />
                    </div>
                    <div className="col-md-4">
                        <div className="row">
                            <PaymentControl
                                availableProviders={this.props.availablePaymentProviders}
                                name="payment"
                                value={{serviceprovider_type: this.props.values.payment}}
                                label="Fizetési mód"
                                saveChanges={(field, value) => this.props.setFieldValue("payment", value.serviceprovider_type)}
                                { ...this.props.getFieldProps('payment') }
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Invoice props={{
                            values: {...this.props.values, seller: this.props.till.pos.partner},
                            getProps: this.getProps, 
                            getValue: this.getValue, 
                            setFieldValue: (field, value) => {if(field === "invoice.comment") field = "comment"; this.props.setFieldValue(field, value);}
                        }} default="seller" { ...this.props.getFieldProps('seller') } />
                    </div>
                </div>
                {this.props.values.customer &&
                <Fragment>
                    {
                        this.state.calculator || !!(this.props.values.items || []).find((item) => !!item.calculator) ? <div className="row form-row">
                            <div className="col-md-6">
                                <DateTimeInput
                                    {...this.props.getFieldProps("startdate")}
                                    name="startdate"
                                    value={this.props.values.startdate}
                                    label="Időszak"
                                    showTime={false}
                                    disabled={true}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                            <div className="col-md-6">
                                <DateTimeInput
                                    {...this.props.getFieldProps("enddate")}
                                    name="enddate"
                                    value={this.props.values.enddate}
                                    label={<Fragment>&nbsp;</Fragment>}
                                    showTime={false}
                                    disabled={true}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div> : null
                    }
                    {!this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                        <div className="col-md-6">
                            <Select
                                name="invoicingitem_type"
                                objectValue={false}
                                labelKey="component"
                                valueKey="component"
                                saveChanges={async (field, value) => {
                                    if (value === 'DummyAdapterItem') {
                                        let item = {component_type: value};
                                        const items = [
                                            ...(this.props.values.items || []),
                                            item
                                        ];
                                        this.props.setFieldValue('items', items);
                                        this.setState({invoicingitem_type: null});
                                    } else {
                                        this.setState({invoicingitem_type: value});
                                    }
                                }}
                                storeType="local"
                                optionsTemplate={(props) => {
                                    return remoteLanguageFormatter("invoicingitem_type")(props[props.valueKey])
                                }}
                                selectedOptionTemplate={(props) => {
                                    return remoteLanguageFormatter("invoicingitem_type")(props[props.valueKey])
                                }}
                                value={this.state.invoicingitem_type}
                                options={this.props.invoicing_types}
                                label="Számla elem hozzáadása"
                                { ...this.props.getFieldProps('invoicingitem_type') }
                            />
                        </div>
                        <Portal>
                            <Modal
                                theme="default"
                                state={!!this.state.addItem}
                                header="Tétel hozzáadás"
                                buttons={[
                                    {
                                        text: "Mégse",
                                        props: {color: "default", disabled: this.props.isLoading},
                                        onClose: true,
                                        onClick: async () => {
                                            this.setState({addItem: false, item: null});
                                        }
                                    },
                                    {
                                        text: "Mehet",
                                        props: {color: "primary", disabled: this.props.isLoading},
                                        onClick: async () => {
                                            await this.props.setFieldValue("startdate", startdate);
                                            await this.props.setFieldValue("enddate", enddate);
                                            await this.loadItem(this.state.item, {startdate, enddate});
                                            this.setState({addItem: false, item: null});
                                        }
                                    }
                                ]}
                            >
                                <div className="row">
                                    <div className="col-md-6">
                                        <DateTimeInput
                                            {...this.props.getFieldProps("startdate")}
                                            name="startdate"
                                            value={startdate}
                                            initialValue={moment().subtract(1, "months").startOf('month').format("YYYY-MM-DD") + " 00:00:00"}
                                            label="Időszak"
                                            showTime={false}
                                            saveChanges={(field, value) => this.props.setFieldValue(field, value + " 00:00:00")}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <DateTimeInput
                                            {...this.props.getFieldProps("enddate")}
                                            name="enddate"
                                            value={enddate}
                                            initialValue={moment().subtract(1, "months").endOf('month').format("YYYY-MM-DD") + " 23:59:59"}
                                            label={<Fragment>&nbsp;</Fragment>}
                                            showTime={false}
                                            saveChanges={(field, value) => this.props.setFieldValue(field, value + " 23:59:59")}
                                        />
                                    </div>
                                </div>
                            </Modal>
                        </Portal>
                        {this.state.invoicingitem_type &&
                        <div className="col-md-6">
                            <Select
                                name="invoicingitem_template"
                                objectValue={true}
                                component={this.state.invoicingitem_type}
                                filter={{
                                    field: "customer", value: this.props.values.customer
                                }}
                                labelKey="name"
                                valueKey="id"
                                saveChanges={async (field, value) => {
                                    if (!!value.calculator) {
                                        if (!(this.props.values.items || []).find((item) => !!item.calculator)){
                                            this.setState({invoicingitem_type: null, addItem: true, item: {component_type: this.state.invoicingitem_type, component_id: value.id}});
                                            return;
                                        } else {
                                            const component_type = this.state.invoicingitem_type;
                                            this.setState({invoicingitem_type: null});
                                            await this.loadItem({component_type, component_id: value.id});
                                            return;
                                        }
                                    } else {
                                        value = { ...value, qty: 1, saleprice: value.listprice, component_type: this.state.invoicingitem_type, component_id: value.id };
                                    }
                                    if (value) {
                                        this.addItem(value);
                                    }
                                    this.setState({invoicingitem_type: null});
                                }}
                                view={['id', 'name', 'calculator', 'unit', 'listprice', 'vat', 'currency', 'comment']}
                                storeType="local"
                                label="Számla elem típusa"
                                { ...this.props.getFieldProps('invoicingitem_template') }
                            />
                        </div>
                        }
                    </div>}
                    <div className="row form-row">
                        <div className="col-sm-12">
                        {!this.props.values[this.props.componentConfig.idfield] ? <SelectorGrid
                                ref={(e) => this.items = e}
                                className={"p-small-table"}
                                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                onItemUpdate={(newItem, oldItem, fieldName, rowIndex) => {
                                    if (!newItem.calculator) {
                                        if (!oldItem.vat) {
                                            oldItem = JSON.parse(JSON.stringify(newItem));
                                        }
                                        if (newItem.vat) {
                                            newItem = this.setPrice(fieldName, newItem, oldItem);
                                        }
                                    }
                                    const items = [...this.props.values.items];
                                    items[rowIndex] = newItem;
                                    this.props.setFieldValue('items', items);
                                }}
                                columns={{
                                    "action": {
                                        header: ' ',
                                        width: 1,
                                        renderer: (value, rowData, rowIndex) => {
                                            return <Actions item={rowData} onItemRemove={() => {
                                                this.props.setFieldValue("items", this.props.values.items.filter((i, index) => index !== rowIndex));
                                            }} { ...this.props.getFieldProps('items') } />
                                        }
                                    },
                                    "name": {
                                        header: 'Megnevezés',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        columnClassName: (field, value) => {
                                            return {"danger color bold": !value};
                                        },
                                        editor: (parent) => (props, value) =>
                                            <TextInput
                                                name="name"
                                                label={false}
                                                focus
                                                value={value}
                                                onKeyDown={(e, field, value) => {
                                                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                }}
                                                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                            />
                                    },
                                    "vat": {
                                        header: "Áfa",
                                        width: "vat",
                                        columnClassName: (field, value) => {
                                            return {"danger color bold": !value};
                                        },
                                        renderer: (value) => <span className={classNames("vat", {"text-center": !value})}>{(value || {}).name || "!"}</span>,
                                        editor:
                                            (parent) =>
                                                (props, value) => !props.rowData.calculator ?
                                                    <Select
                                                        name="vat"
                                                        component="vatrate"
                                                        filter={{field: "active", value: 1}}
                                                        objectValue={true}
                                                        label={false}
                                                        storeType="local"
                                                        value={value}
                                                        view={["rate"]}
                                                        saveChanges={(field, value) => {
                                                            parent.onEditorValueChange(props, value);
                                                        }}
                                                    /> : null
                                    },
                                    "listprice": {
                                        header: 'Lista ár',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        editor: (parent) => (props, value) => !props.rowData.calculator ?
                                            <TextInput
                                                type="decimal"
                                                name="listprice"
                                                label={false}
                                                focus
                                                value={value}
                                                onKeyDown={(e, field, value) => {
                                                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                }}
                                                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                            /> : null
                                    },
                                    "saleprice": {
                                        header: 'Eladási ár',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter
                                    },
                                    "saleprice_net": {
                                        header: 'Nettó egységár',
                                        width: 1,
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                        columnClassName: (field, value) => {
                                            return {"danger color bold": !value};
                                        },
                                        editor:
                                            (parent) =>
                                                (props, value) => !props.rowData.calculator ?
                                                    <TextInput
                                                        type="decimal"
                                                        name="saleprice_net"
                                                        label={false}
                                                        focus="focus"
                                                        value={value}
                                                        onKeyDown={(e, field, value) => {
                                                            ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                        }}
                                                        onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                                    /> : null
                                    },
                                    "saleprice_gross": {
                                        header: 'Bruttó egységár',
                                        width: 1,
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                        columnClassName: (field, value) => {
                                            return {"danger color bold": !value};
                                        },
                                        editor:
                                            (parent) =>
                                                (props, value) => !props.rowData.calculator ?
                                                    <TextInput
                                                        type="decimal"
                                                        name="saleprice"
                                                        label={false}
                                                        focus="focus"
                                                        value={value}
                                                        onKeyDown={(e, field, value) => {
                                                            ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                        }}
                                                        onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                                    /> : null
                                    },
                                    "qty": {
                                        header: 'Összesen',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        className: "unit",
                                        columnClassName: (field, value) => {
                                            return {"danger color bold": !value};
                                        },
                                        renderer: (value, row) => UnitFormatter(value, ' '),
                                        editor: (parent) => (props, value) => !props.rowData.calculator ?
                                            <TextInput
                                                type="number"
                                                name="qty"
                                                label={false}
                                                focus
                                                value={value}
                                                onKeyDown={(e, field, value) => {
                                                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                }}
                                                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                            /> : null
                                    },
                                    "unit": {
                                        header: 'Egység',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        columnClassName: (field, value) => {
                                            return {"danger color bold": !value};
                                        },
                                        editor: (parent) => (props, value) => !props.rowData.calculator ?
                                            <TextInput
                                                name="unit"
                                                label={false}
                                                focus
                                                value={value}
                                                onKeyDown={(e, field, value) => {
                                                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                }}
                                                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                            /> : null
                                    },
                                    "saleprice_net_total": {
                                        header: 'Nettó összeg',
                                        width: 1,
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                        columnClassName: (field, value) => {
                                            return {"danger color bold": !value};
                                        },
                                        editor: (parent) => (props, value) => !props.rowData.calculator ?
                                            <TextInput
                                                name="saleprice_net_total"
                                                label={false}
                                                focus
                                                value={value}
                                                onKeyDown={(e, field, value) => {
                                                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                }}
                                                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                            /> : null
                                    },
                                    "saleprice_gross_total": {
                                        header: 'Bruttó összeg',
                                        width: 1,
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                        columnClassName: (field, value) => {
                                            return {"danger color bold": !value};
                                        },
                                        editor: (parent) => (props, value) => !props.rowData.calculator ?
                                            <TextInput
                                                name="saleprice_gross_total"
                                                label={false}
                                                focus
                                                value={value}
                                                onKeyDown={(e, field, value) => {
                                                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                }}
                                                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                            /> : null
                                    },
                                    "comment": {
                                        header: 'Megjegyzés',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        editor: (parent) => (props, value) =>
                                            <TextInput
                                                name="comment"
                                                label={false}
                                                focus
                                                value={value}
                                                onKeyDown={(e, field, value) => {
                                                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                                }}
                                                onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                            />
                                    },
                                }}
                                //name="items"
                                //data={this.props.values}
                                orderBy={{field: "name", direction: "ASC"}}
                                //componentConfig={this.props.componentConfig}
                                value={this.props.values.items || []}
                                component="InvoicingItem"
                                
                            /> : 
                            <SelectorGrid
                                ref={(e) => this.items = e}
                                className={"p-small-table"}
                                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                view={["report_component_id"]}
                                columns={{
                                    "name": {
                                        header: 'Megnevezés',
                                        width: 2,
                                        sortable,
                                        filterable
                                    },
                                    "listprice": {
                                        header: 'Lista ár',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter
                                    },
                                    "saleprice": {
                                        header: 'Eladási ár',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter
                                    },
                                    "saleprice_net": {
                                        header: 'Nettó egységár',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter
                                    },
                                    "vat": {
                                        header: "Áfa",
                                        width: "vat",
                                        renderer: (value) => <span className="vat">{(value || {}).name}</span>,
                                    },
                                    "saleprice_gross": {
                                        header: 'Bruttó egységár',
                                        width: 1,
                                        renderer: CurrencyFormatter,
                                        className: "currency",
                                    },
                                    "qty": {
                                        header: 'Összesen',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: (value, row) => UnitFormatter(value, ' '),
                                    },
                                    "unit": {
                                        header: 'Egység',
                                        width: 1,
                                        sortable,
                                        filterable,
                                    },
                                    "saleprice_net_total": {
                                        header: 'Nettó összeg',
                                        width: 1,
                                        renderer: CurrencyFormatter,
                                    },
                                    "saleprice_gross_total": {
                                        header: 'Bruttó összeg',
                                        width: 1,
                                        renderer: CurrencyFormatter,
                                    },
                                    "comment": {
                                        header: 'Megjegyzés',
                                        width: 2,
                                        sortable,
                                        filterable
                                    },
                                    "report_component_type": {
                                        header: 'Riport',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        renderer: (value, rowData) => !!rowData.report_component_type && <PrintButton
                                            component_type={rowData.report_component_type}
                                            component_id={rowData.report_component_id}
                                            type="excel"
                                            icon={{lib: "fas", name: "download"}}
                                        >
                                            Letöltés
                                        </PrintButton>
                                    }
                                }}
                                listfield="items"
                                data={this.props.values}
                                orderBy={{field: "name", direction: "ASC"}}
                                componentConfig={this.props.componentConfig}
                            />}
                        </div>
                    </div>
                </Fragment>
                }
            </form>
        );
    }
}

export default createForm(InvoicingForm);
